import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

export default class Fish extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    /** @type {Phaser.GameObjects.Image[]} */
    this.fishies = [];
    this.tweens = [];

    this.dir = null;
    this.startPos = null;

    this.fishXTween = null;
    this.fishYTween = null;

    this.setup();
  }

  setup() {
    this.createFishPos();
    this.createSchool();
  }

  createFishPos () {
    if (gameData.config.level === 4) {
      this.posArray =
				[{ x: 0,y: 0 },
				  { x: 30,y: 25 },
				  { x: -50,y: 25 },
				  { x: -30,y: -25 },
				  { x: 30,y: -25 },
				  { x: 0,y: -40 },
				  { x: 0,y: 40 },
				  { x: 40,y: 0 },
				  { x: -40,y: 0 }
				];
    }
    else {
      this.posArray =
				[{ x: 0,y: 0 },
				  { x: 50,y: 25 },
				  { x: -80,y: 25 },
				  { x: -50,y: -25 },
				  { x: 50,y: -25 },
				  { x: 0,y: -40 },
				  { x: 0,y: 40 },
				  { x: 70,y: 0 },
				  { x: -70,y: 0 },
				  { x: 70,y: 50 },
				  { x: 70,y: -50 },
				  { x: 30,y: -70 },
				  { x: 30,y: 70 },
				  { x: -30,y: -70 },
				  { x: -30,y: 70 },
				  { x: -60,y: -50 },
				  { x: -60,y: 50 },
				  { x: 110,y: -30 },
				  { x: 110,y: 30 },
				  { x: 120,y: 0 }
				];
    }
  }

  createSchool () {
    const randNum = Phaser.Math.Between(4, 8);
    const startY = Phaser.Math.Between(this.scene.scale.height - 180, this.scene.scale.height - 50);

    Phaser.Utils.Array.Shuffle(this.posArray);

    if (gameData.config.level === 4) {
      this.dir = 'right';
      this.startPos = { x: 0, y: startY };

      for (let d = 0; d < randNum; d++) {
        const rand4X = Phaser.Math.Between(-15, 15);
        const rand4Y = Phaser.Math.Between(-15, 15);

        const fishes = ABCyaPhaser.Images.addImage(this.posArray[d].x + rand4X, this.posArray[d].y + rand4Y, UIAssetKeys._Lvl4_Fish, this);

        if (this.dir === 'left') fishes.scaleX = -1;
        if (this.dir === 'right') fishes.scaleX = 1;

        this.fishies.push(fishes);
        this.moveFish(fishes);
      }
    }
    else {
      if (this.dir === null) {
        const randStart = Phaser.Math.Between(1, 2);

        if (randStart === 1) {
          this.dir = 'right';
        }
        else {
          this.dir = 'left';
        }
      }

      if (this.dir === 'right') {
        this.startPos = { x: -200, y: startY };
      }
      else {
        this.startPos = { x: this.scene.scale.width + 200, y: startY };
      }

      for (let i = 0; i < randNum; i++) {
        const randX = Phaser.Math.Between(-15, 15);
        const randY = Phaser.Math.Between(-15, 15);

        let fishRef = UIAssetKeys._bgFish;
        if (gameData.config.level === 2) {
          fishRef = UIAssetKeys._Lvl2_Fish;
        }
        const fish = ABCyaPhaser.Images.addImage(this.posArray[i].x + randX, this.posArray[i].y + randY, fishRef, this);

        if (this.dir === 'right') fish.scaleX = -1;

        this.fishies.push(fish);
        this.moveFish(fish);
      }
    }

    this.setPosition(this.startPos.x, this.startPos.y);

    this.moveSchool();
  }

  moveFish (fish) {
    const randX = Phaser.Math.FloatBetween(-10, 10);
    const randY = Phaser.Math.FloatBetween(-10, 10);
    const randTime = Phaser.Math.Between(1500, 3000);

    ABCyaPhaser.Tweens.addTween(fish, randTime, { x: fish.x + randX, y: fish.y + randY, yoyo: true }, Phaser.Math.Easing.Sine.InOut, () => {
      this.moveFish(fish);
    });
  }

  moveSchool () {
    let randTime;
    let dirX;
    if (gameData.config.level === 4) {
      const randDel = Phaser.Math.Between(0, 10000);
      randTime = Phaser.Math.Between(5000, 10000);
      dirX = 150;

      this.fishYTween = ABCyaPhaser.Tweens.addTween(this, 5000, { y: this.startPos.y + 30, delay: randDel, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Sine.InOut);
      this.fishXTween = ABCyaPhaser.Tweens.addTween(this, randTime, { x: dirX, delay: randDel, yoyo: true, hold: randDel }, Phaser.Math.Easing.Linear, () => {
        this.newSchool();
      });
    }
    else {
      randTime = Phaser.Math.Between(20000, 40000);

      if (this.dir === 'right') {
        dirX = this.scene.scale.width + 300;
      }
      else {
        dirX = -300;
      }

      this.fishYTween = ABCyaPhaser.Tweens.addTween(this, 5000, { y: this.startPos.y + 30, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Sine.InOut);
      this.fishXTween = ABCyaPhaser.Tweens.addTween(this, randTime, { x: dirX }, Phaser.Math.Easing.Linear, () => {
        this.newSchool();
      });
    }
  }

  newSchool () {
    if (this.dir === 'right') {
      this.dir = 'left';
    }
    else {
      this.dir = 'right';
    }

    this.cleanUp();

    this.createSchool();
  }

  cleanUp () {
    for (let l = 0; l < this.fishies.length; l++) {
      this.scene.tweens.killTweensOf(this.fishies[l]);
      this.fishies[l].destroy();
    }
    this.fishies = [];

    this.scene.tweens.killTweensOf(this);
    this.fishXTween?.stop();
    this.fishYTween?.stop();
  }
}